export default function multiClassName(
  ...classNames: (string | undefined)[]
): string {
  return classNames.filter((c) => c).join(" ");
}
